import React, { useEffect } from 'react';
import { FiPhone, FiMail } from 'react-icons/fi';
import '../styles/ContactModal.css';
import analyticsService from '../services/analyticsService';
import { formatPhoneNumber } from '../utils/phoneUtils';

const ContactModal = ({ agentInfo, onClose, show, isMobile }) => {
  // Preload the balloon logo image
  useEffect(() => {
    const preloadImage = () => {
      const img = new Image();
      img.src = '/images/rmxballoonz.png';
    };
    preloadImage();
  }, []);

  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose} aria-label="Close contact modal">
          ×
        </button>
        <img
          src="/images/rmxballoonz.png"
          width="50"
          height="50"
          loading="eager"
          decoding="async"
          fetchpriority="high"
          alt="Balloon Logo"
          className="modal-balloon-logo"
        />
        <div className="modal-contact-header">
          <h3 className="modal-agent-name">{agentInfo?.office || 'REMAX Key Properties'}</h3>
          <p className="modal-agent-company">42 NW Greenwood Ave. Bend, OR 97703</p>
          {/* Hide secondary logo on mobile and only show section title on desktop */}
          {!isMobile && (
            <p className="modal-agent-title">Open House Information</p>
          )}
        </div>

        {agentInfo ? (
          <>
            {/* Static name and company are now above, in modal-contact-header */}
            {agentInfo.phone && (
              <p className="contact-info-item">
                <FiPhone className="contact-icon" />
                <a 
                  href={`tel:${agentInfo.phone}`}
                  onClick={() => {
                    analyticsService.trackContact('Phone Call', agentInfo.name || 'Unknown Agent', {
                      source: 'Contact Modal'
                    });
                  }}
                >
                  {formatPhoneNumber(agentInfo.phone)}
                </a>
              </p>
            )}
            {agentInfo.email && (
              <p className="contact-info-item">
                <FiMail className="contact-icon" />
                <a 
                  href={`mailto:${agentInfo.email}`}
                  onClick={() => {
                    analyticsService.trackContact('Email', agentInfo.name || 'Unknown Agent', {
                      source: 'Contact Modal'
                    });
                  }}
                >
                  {agentInfo.email}
                </a>
              </p>
            )}
          </>
        ) : (
          <p>Contact information is not available.</p>
        )}
      </div>
    </div>
  );
};

export default ContactModal;
